import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {IStringAnyMap, BooxSessionService} from "lib-boox";

@Component({
  selector: 'host-forgot-password',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  public controlEmail: FormControl = new FormControl('', [Validators.required, Validators.email]);

  public forgotPasswordForm: FormGroup;

  private _sending : boolean = false;

  @Input() public email: string = '';

  @Output('success') public success: EventEmitter<void> = new EventEmitter<void>();
  @Output('failed') public failed: EventEmitter<IStringAnyMap> = new EventEmitter<IStringAnyMap>();

  constructor(
    private session : BooxSessionService,
  ){

    this.controlEmail.setValue(this.email);

    this.forgotPasswordForm = new FormGroup({
      email: this.controlEmail,
    });

  }

  public send(){
    if(this.forgotPasswordForm.invalid) return;
    this._sending = true;
    this.session.forgotPassword(this.forgotPasswordForm.value).subscribe({
      next: () => {
        this.success.emit();
        this._sending = false;
      },
      error: (error) => {
        this.failed.emit(error);
        this._sending = false;
      },
    });
  }

  public get disabled(){
    return this.forgotPasswordForm.invalid || this._sending;
  }
}
